import type { ComponentProps } from "react";

export type LgStatusProps = ComponentProps<"div"> & {
  /** quiet は薄い罫の箱、strong は墨の太い枠の箱 (結果) */
  tone?: "quiet" | "strong";
};

/** 状態や結果を知らせる箱。読み上げに渡すときは呼ぶ側が role="status" を付ける。影なし、角 2px */
export function LgStatus({ tone = "quiet", className, ...props }: LgStatusProps) {
  return <div {...props} className={`lg-status lg-status--${tone}${className ? ` ${className}` : ""}`} />;
}
